import client, { endpoints } from '../api/client';
import { APIKEYS } from '../constants/actionTypes';

const errMsg = (e) => e?.response?.data?.error || e?.message || 'Unknown error.';

export const fetchApiKeys = () => async (dispatch) => {
  dispatch({ type: APIKEYS.LIST_REQUEST });
  try {
    const { data } = await client.get(endpoints.accessTokens.list);
    dispatch({ type: APIKEYS.LIST_SUCCESS, payload: data.items });
  } catch {}
};
export const createApiKey = (name, scopes) => async (dispatch) => {
  try {
    const { data } = await client.post(endpoints.accessTokens.create, { name, scopes });
    dispatch({ type: APIKEYS.CREATE, payload: data.token });
    return { ok: true, token: data.token };
  } catch (e) { return { ok: false, error: errMsg(e) }; }
};
export const revokeApiKey = (id) => async (dispatch) => {
  try { await client.delete(endpoints.accessTokens.revoke(id)); dispatch({ type: APIKEYS.REMOVE, payload: id }); return { ok: true }; }
  catch (e) { return { ok: false, error: errMsg(e) }; }
};
export const rotateApiKey = (id) => async () => {
  try { const { data } = await client.post(endpoints.accessTokens.rotate(id)); return { ok: true, token: data.token }; }
  catch (e) { return { ok: false, error: errMsg(e) }; }
};
